import { Flex, FlexProps } from "@chakra-ui/react";

import { IconLeftArrow } from "@ud/icons";
import Button from "components/Chakra/Button";
import CustomLink from "components/Chakra/CustomLink";
import { useOfferInsert } from "contexts/InsertOffer";

interface IStepBtnsProps extends FlexProps {
  buttonPrevText?: string;
  buttonNextText?: string;
  checkIsBtnDisable?: () => boolean;
}

const StepButtons: React.FC<IStepBtnsProps> = ({
  buttonNextText = "Pokračovat",
  buttonPrevText = "Zpět",
  checkIsBtnDisable,
  ...props
}) => {
  const { prevStep } = useOfferInsert();

  const { url, query } = prevStep();

  const isLinkDisabled = checkIsBtnDisable && checkIsBtnDisable();

  return (
    <Flex
      w="100%"
      alignItems="center"
      mt={[null, "40px"]}
      p={["16px", 0]}
      direction="row"
      bg={["ud-white", "unset"]}
      zIndex={[1020, "unset"]}
      position={["fixed", "unset"]}
      left="0"
      bottom="0"
      justifyContent="space-between"
      gap={[null, "24px"]}
      borderTop={["1px solid", "unset"]}
      borderColor="ud-grey-300"
      {...props}
    >
      <CustomLink to={url} fontWeight="bold" routeProps={query}>
        <IconLeftArrow fill="ud-primary" />
        {buttonPrevText}
      </CustomLink>

      <Button px="40px" h="38px" type="submit" isDisabled={isLinkDisabled}>
        {buttonNextText}
      </Button>
    </Flex>
  );
};

export default StepButtons;
